<div class="element-row" style="position: absolute; top: -33px; right: 109px;">
  <label aria-label="編集ロック" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button {{clsLock}}" id="icnEditLock" #icnEditLock (click)="eventEditLock_CLICKHandler()"
      forcedEnabledMode="none" [tabindex]="0">
      <img src="{{kymw1300Model.srcLock}}">
    </button>
  </label>
  <label aria-label="表示切替" data-microtip-position="bottom" role="tooltip">
    <button class="icon-button" id="icnDispChange" (click)="toggleSelectTargetListView()" [tabindex]="0">
      <img src="{{kymw1300Model.srcDisp}}">
    </button>
  </label>
</div>

<div class="contents-area">
  <div class="block-column">
    <!-- 基本・選定 -->
    <div class="block-row layout_balance" style="min-width: 1480px;">
      <div class="block-row" style="min-width: 930px;">
        <div class="column-list" style="grid-template-columns: auto 1fr;">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input [width]="80" id="txt_OrderCode" #txt_OrderCode [subid]="'txt_OrderCode'" (focusout)="eventOrederCode_FOCUSOUTHandler()"
              [(ngModel)]="kymw1300Model.orderCode" [autofocus]="true" [catalogIDField]="lbl_DelivCatalogId"
              [registCycleField]="lbl_RegistCycle" (ngModelChange)="eventOrderCode_CHANGEHandler()"
              [forcedEnabledMode]="'true'" [tabindex]="0">
            </app-order-code-text-input>
          </div>
        </div>

        <div class="column-list" style="grid-template-columns: auto 1fr;">
          <label class="list-input-title">配達企画回</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_DelivCatalogId" #lbl_DelivCatalogId readonly>
            <input type="text" style="width:40px;" id="lbl_RegistCycle" #lbl_RegistCycle readonly>
          </div>
        </div>

        <div class="column-list" style="grid-template-columns: auto 1fr;">
          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <select class="combo-box-normal" forcedEnabledMode="true" [tabindex]="0" id="cmb_MediumType" #cmb_MediumType
              [(ngModel)]="kymw1300Model.mediumType" style="width:240px"
              (ngModelChange)="eventMediumType_CHANGEHandler()">
              <ng-template ngFor let-item [ngForOf]="kymw1300Model.mediumTypeList">
                <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
              </ng-template>
            </select>
          </div>
        </div>

        <div class="column-list" style="grid-template-columns: auto 1fr;">
          <label class="list-input-title">束ね企画名</label>
          <div class="list-input-content">
            <select class="combo-box-normal" style="width:320px;"
              [disabled]="!kymw1300Model.enabledBundleCatalogGuideStandardName" id="cmb_BundleCatalogGuideStandardName"
              #cmb_BundleCatalogGuideStandardName forcedEnabledMode="true" [tabindex]="0"
              [(ngModel)]="kymw1300Model.bundleCatalogGuideStandardName"
              (change)="eventBundleCatalogGuideStandardName_CHANGEHandler($event)">
              <ng-template ngFor let-item [ngForOf]="kymw1300Model.bundleCatalogRoundInfoList">
                <option value="{{item.BundleCatalogRoundId}}">{{item.BundleCatalogRoundName}}</option>
              </ng-template>
            </select>
            <input type="text" class="deliv-catalog" readonly
              [(ngModel)]="kymw1300Model.startOrderCode">
            <label>～</label>
            <input type="text" class="deliv-catalog" readonly
              [(ngModel)]="kymw1300Model.endOrderCode">
          </div>
        </div>

        <div class="column-list" style="grid-template-columns: auto 1fr;">
          <label class="list-input-title">売り場</label>
          <div class="list-input-content">
            <app-sell-area-code-combo-box [width]="160" id="cmb_SellArea" #cmb_SellArea [subid]="'cmb_SellArea'"
              [(ngModel)]="kymw1300Model.sellAreaCode" [mediumType]="kymw1300Model.mediumType"
              (loadCompleted)="sellAreaCodeLoadCompleted($event)" (ngModelChange)="eventSellArea_CHANGEHandler()"
              [forcedEnabledMode]="'true'" [tabindex]="0"
              [initFocusItem]="txt_OrderCode"></app-sell-area-code-combo-box>
          </div>
        </div>
      </div>
    </div>
    <!-- 基本・利用人数計画 -->
    <div class="block-row">
      <table [style.width.px]="500" class="kymw1300-table">
        <tr>
          <th [style.width.px]="264" colspan="4" style="text-align: center;">{{kymw1300Model.delivCatalogId}}</th>
        </tr>
        <tr>
          <th [style.width.px]="66">配布開始</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.distributionStartDate}}</td>
          <th [style.width.px]="66">配布終了</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.distributionEndDate}}</td>
        </tr>
        <tr>
          <th [style.width.px]="66">配達開始</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.delivStartDate}}</td>
          <th [style.width.px]="66">配達終了</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.delivEndDate}}</td>
        </tr>
      </table>

      <table [style.width.px]="250" class="kymw1300-table">
        <tr>
          <th [style.width.px]="80">企画仮確定</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.catalogTempFixDate}}</td>
        </tr>
        <tr>
          <th [style.width.px]="66">予定連絡</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.catalogScheduleContactDate}}</td>
        </tr>
        <tr>
          <th [style.width.px]="66">PDF送信</th>
          <td [style.width.px]="66" class="align-left">{{kymw1300Model.pdfSendDate}}</td>
        </tr>
      </table>

      <table [style.width.px]="1000" class="kymw1300-table">
        <tr>
          <th [style.width.px]="540" colspan="8" style="text-align: center;">利用人数計画</th>
        </tr>
        <tr>
          <th [style.width.px]="60">いばらき</th>
          <th [style.width.px]="60">とちぎ</th>
          <th [style.width.px]="60">ぐんま</th>
          <th [style.width.px]="60">ちば</th>
          <th [style.width.px]="60">さいたま</th>
          <th [style.width.px]="60">とうきょう</th>
          <th [style.width.px]="60">ながの</th>
          <th [style.width.px]="60">にいがた</th>
        </tr>
        <tr>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumIB}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumTO}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumGU}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumTI}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumSA}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumTK}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumNA}}</td>
          <td [style.width.px]="60" class="align-right">{{kymw1300Model.usedNumNI}}</td>
        </tr>
      </table>
    </div>
  </div>

  <!-- 上段・選定候補一覧 -->
  <app-kymw1300-target-list id="kymw1300_02" #kymw1300_02 [parentModel]="kymw1300Model"
    style="min-width: 1480px; min-height: 541px;" [style.display]="3 === kymw1300Model.cntDispChange ? 'none' : 'flex'">
  </app-kymw1300-target-list>
  <!-- 下段・選定済一覧 -->
  <app-kymw1300-selected-list id="kymw1300_03" #kymw1300_03 [parentModel]="kymw1300Model"
    style="min-width: 1480px; min-height: 515px;" [style.display]="2 === kymw1300Model.cntDispChange ? 'none' : 'flex'">
  </app-kymw1300-selected-list>
</div>